export const DEFAULT_CUSTOM_STYLESHEET = '/* Your CSS styles here */'
